<template>
    <div>
        <!--Begin-->
        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-3">
                <label for="">Type de Prospects</label>
                <select @change="changeProspect()" id="prospectValue" class="form-control">
                    <option value="">Tous</option>
                    <!-- <option value="1">Demande de creation de compte</option> -->
                    <option value="2">Ayant demandé une negociation</option>
                    <option value="3">Ayant sauvegardé une souscription</option>
                </select>
            </div>
            <div class="col-sm-12 col-md-3">
                <label for="">Date de debut</label>
                <input type="date" v-model="tableData.date_debut" class="form-control">
                <div v-if="errors.date_debut" style="color: red">
                      {{ errors.date_debut[0] }}
                </div>
            </div>
            <div class="col-sm-12 col-md-3">
                <label for="">Date de fin</label>
                <input type="date" v-model="tableData.date_fin" class="form-control">
                <div v-if="errors.date_fin" style="color: red">
                      {{ errors.date_fin[0] }}
                </div>
            </div>
            <div class="col-sm-12 col-md-3 mt-3 mb-2 d-flex justify-content-around">
                <button @click="filtrerData()" class="btn btn-primary">
                    Filtrer
                </button>
                <button @click="exportData()" class="btn btn-primary" id="export_btn" :class="exporting || prospects.length === 0 ? 'disabled' : ''">
                    <span v-if="exporting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Exporter
                </button>
            </div>
 
        </div>
        <!--End-->
        <div class="d-flex justify-content-between align-items-center row">
            <div class="col-sm-12 col-md-1">
                <select style="width:60px !important" class="form-control" v-model="tableData.length" @change="changePerPage()">
                    <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                </select>
            </div>
            <div class="mb-2 col-md-3 text-right">
                <input class="form-control" type="text" v-model="tableData.search"
                   @input="getSearch()">
            </div>
        </div>
        <v-table :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
            <tbody>
                <tr class="pointer" @click="showDetail(prospect.id)" v-for="prospect in prospects" :key="prospect.id">
                    <td>{{prospect.last_name}}</td>
                    <td>{{prospect.first_name}}</td>
                    <td>{{prospect.phone}}</td>
                    <td>{{prospect.email}}</td>
                    <td>
                        <span style="color: black" class="badge badge-pill badge-light" v-if="prospect.status == null">Nouveau</span>
                        <span class="badge badge-pill badge-success" v-if="prospect.status == '1'">Activé</span>
                        <span class="badge badge-pill badge-danger" v-if="prospect.status == '0'">Rejeté</span>
                    </td>
                </tr>
            </tbody>
        </v-table>
        <v-paginate :links="links" :navigationFunction="navigation"/>
    </div>
</template>

<script>
import {api, _buildQuery } from "../../../../helpers/shared";
import vTable from '../../../../components/vTable/vTable.vue';
import vPaginate from '../../../../components/vTable/vPaginate1.vue'
import axios from 'axios';
import  debounce  from 'lodash/debounce'
export default {
    components:{
        vTable, vPaginate,
    },
    mounted(){
        this.getProspects()
    },
    data() {
        let sortOrders = {};
        let columns = [
            {width: '33%', label: 'Nom', name: 'last_name' },
            {width: '33%', label: 'Prénom(s)', name: 'first_name'},
            {width: '33%', label: 'Téléphone', name: 'phone'},
            {width: '33%', label: 'Email', name: 'email'},
            {width: '33%', label: 'Statut', name: 'status'}
        ];
        return {
            links: [],
            errors: [],
            exporting: false,
            prospects: [],
            columns: columns,
            sortKey: '',
            sortOrders: sortOrders,
            perPage: ['10', '20', '30'],
            tableData: {
                page: 0,
                length: 10,
                search: '',
                column: 0,
                dir: 'desc',
                state: 'all',
                date_debut:'',
                date_fin:'',
            },
        }
    },
    methods: {
        showDetail(uuid){
            this.$router('/administration/prospects/'+uuid+'.content')
        },
        getWithProduct(val){
            this.tableData.product = val;
            this.changePerPage();
        },
        changePerPage(url = 'administration/prospects'){
            this.tableData.page = 1;
            axios.get(api(url), {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getNext(url){
            this.tableData.page ++;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getPrev(url){
            this.tableData.page --;
            axios.get(url, {params: this.tableData})
            .then(response => {
                let content = response.data;
                this.prospects = content.data;
                this.configPagination(content);
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        getProspects(url = 'administration/prospects') {
            let loader = this.$loading.show({
                    container: null,
                    canCancel: false,
                    color: "#4B4B4B",
                    backgroundColor: "#4B4B4B",
                    height: 35,
                    width: 35,
                    loader: "bars",
                    opacity: 0.3,
            });
            //this.tableData.page++;
            axios.get(api(url), {params: this.tableData})
                .then(response => {
                    loader.hide();
                    let content = response.data;
                    this.prospects = content.data;
                    this.configPagination(content);
                })
                .catch(errors => {
                    console.log(errors);
                });
        },
        configPagination(data) {
            this.links = data.links;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
            this.getProspects();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        getSearch: debounce(function (e) {
            this.changePerPage()
        }, 500),
        changeProspect(){
            let pv = document.querySelector("#prospectValue")
            //console.log("Valeur de pv:",pv.value)
            if(pv.value ==1){
                this.tableData.state ="all"
                this.getProspects()
            }else if(pv.value == 2){
                this.tableData.state ="negotiated"
                this.getProspects()
            }else if(pv.value == 3){
                this.tableData.state ="save"
                this.getProspects()
            }else{
                this.tableData.state ="all"
                this.getProspects()
            }
           
        },
        
        exportData(){
            
            this.exporting = true;
                axios.get(api('administration/prospect_excel_new'),{params: this.tableData,responseType: 'arraybuffer'}).then((response) => {
                    let data = response.data;
                    //console.log("Valeur de data:",data)
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', 'prospects_from_vue.xlsx');
                        document.body.appendChild(fileLink);
                        fileLink.click();  
                    this.exporting = false;
                }).catch((error) => {
                    this.exporting = false;
                    if (error.response.status !== 422){
                        this.$toasted.global.error({message: "Votre connexion a expiré"})
                    }else this.$toasted.global.error({message: "Une erreur est survenu lors de l'exportation"})
                })
        },

        filtrerData(){
                axios.get(api('administration/verify_prospect_excel_dates'),{params: this.tableData}).then((response) => {
                    let content = response.data;
                    this.prospects = content.data;
                    this.configPagination(content);
                    this.errors = [];
                }).catch((error) => {
                    if (error.response.status !== 422){
                        this.$toasted.global.error({message: "Votre connexion a expiré"})
                    }else if(error.response.status === 422){
                        this.errors = error.response.data.errors;
                    }
                    else this.$toasted.global.error({message: "Une erreur est survenu lors de l'exportation"})
                })
        },
        navigation(page) {
                this.tableData.page = page;
                axios.get(api('administration/prospects'), {params: this.tableData})
                    .then(response => {
                        let content = response.data;
                        this.prospects = content.data;
                        this.configPagination(content);
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
        },
    }
}
</script>

<style lang="scss" scoped>
    .pointer{
        cursor: pointer;
    }
</style>
